define.alias("ember-truth-helpers/helpers/or", "media/helpers/or");